module.exports = __webpack_public_path__ + "assets/img/estimate-1.97eabed3.jpg";